import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
import List from '../../components/Entity/Logs/List/List';

const LogsPage = () => {
  return <Layout title={'ლოგი'} fullwidth={0}>
       <List></List>
   </Layout>;
}

export default LogsPage;
